import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../Footer/Footer";
import Sidebar1 from "../Sidebar/Sidebar1";
import Header from "../Header/Header";

function Layout() {
  return (
    <>
      <div className="mainRoot">
        <Sidebar1 />
        <div className="mainContent">
          <Header />
          <div className="px-5 py-4">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
}

export default Layout;
